
import React from 'react';
import { BrowserRouter, Route } from 'react-router-dom'

import Index from '../component/common/Index';
import TradeLargeScreen from '../component/trade/largeScreen/Index';
// import AuctionLargeScreen from '../component/auction/largescreen/Index';
// import AuctionPage from '../component/auction/largescreenNew/Index';
import AuctionTable from '../component/auction/largescreenNew0/AuctionedTable';
import AuctionPage from '../component/auction/largescreenNew0/AuctionPage';
import AuctionLots from '../component/auction/largescreenNew0/AuctionLots';
import Visitor from '../component/auction/visitor/Visitor';
import WechatBindAccount from '../component/wechat/account/Index';
// import LotsDetail from '../component/auction/largescreen/LotsDetail';
// import LotsDetail from '../component/auction/largescreenNew/LotsDetail';
import LotsDetail from '../component/auction/largescreenNew0/LotsDetail';
// import AuctionPage from '../component/auction/largescreenNew0/AuctionPage';
import FinancialDetail from '../component/wechat/financial/FinancialDetail'

//微信公众号，管理端主界面
import wxConsoleIndex from '../component/wechat/common/ConsoleIndex';
//微信公众号，管理端登录界面
import WechatLogin from '../component/wechat/common/WechatLogin';
//微信公众号，游客端主界面
import wxAccessIndex from '../component/wechat/common/AccessIndex';
//测试图片页面
import ReportImage from '../component/mall/exportCheckReport/ReportImage';

import menuData from './menu_wxgzh'; //公众号的菜单

const MainRoute = () => {
    let routeList = [];
    for (let code in menuData) {
        routeList.push(<Route key={code} path={menuData[code]["url"]} component={menuData[code]["component"]} />);
    }
    return (
        <BrowserRouter basename='/'>
            {/* 主管理后台界面 */}
            <Route exact path="/" component={Index} />
            {/* 相关大屏展示界面 */}
            <Route path="/large/trade" component={TradeLargeScreen} />
            <Route path="/large/auction" component={AuctionTable} />
            <Route path="/large/lotsDetail" component={LotsDetail} />
            <Route path="/large/auctioning" component={AuctionPage} />
            <Route path="/large/auctionLots" component={AuctionLots} />
            {/* h5连接，游客访问界面 */}
            <Route path="/visitor/auction" component={Visitor} />
            {/* 微信服务号管理端相关界面 */}
            <Route path="/wx/console/index" component={wxConsoleIndex} />
            <Route path="/wx/console/login" component={WechatLogin} />
            {routeList.map(item => { return item })}

            {/* 微信服务号游客端相关界面 */}
            <Route path="/wx/access/index" component={wxAccessIndex} />

            <Route path="/wx/login" component={WechatBindAccount} />
            <Route path="/wx/financialDetail" component={FinancialDetail} />
            <Route path="/visitor/img" component={ReportImage} />
        </BrowserRouter>
    )
}
export default MainRoute;